import BankWebViewStyles from "./BankWebView.module.css";
import axisbank from "../../../ui-utils/photos/axis.png";
import hdfcbank from "../../../ui-utils/photos/hdfcmob.png";
import icicibank from "../../../ui-utils/latestPics/icici.svg";
import { Grid2, Typography } from "@mui/material";
import en from "../../../i18n/English/Aboutus/research.json";
import hi from "../../../i18n/Hindi/Aboutus/research.json";
import kn from "../../../i18n/Kannada/Aboutus/research.json";
import ma from "../../../i18n/Marathi/Aboutus/research.json";
import gu from "../../../i18n/Gujarati/Aboutus/research.json";
import { useLanguage } from "../../../Context/LangContext";
export default function WebView() {
  const { language } = useLanguage();
  const translations = { en, hi, kn,gu,ma };
  const t = translations[language] || translations.en;
  return (
    <>
      <Grid2 className={BankWebViewStyles.bank_main}>
        <div className={BankWebViewStyles.title_card}>
          <h1 className={BankWebViewStyles.bank_title}>
            {t.bank}
          </h1>
        </div>

        <Grid2 className={BankWebViewStyles.inner_card}>
          <Grid2 className={BankWebViewStyles.bank_card1}>
            <div className={BankWebViewStyles.img_div}>
              {/* <Typography className={BankWebViewStyles.bankname}>
                Axis Bank
              </Typography> */}
              <img
                src={axisbank}
                className={BankWebViewStyles.bank_img1}
                alt="bank"
              ></img>
            </div>
          </Grid2>

          <Grid2 className={BankWebViewStyles.middle_line}></Grid2>
          <Grid2 className={BankWebViewStyles.bank_card2}>
            {/* <Typography className={BankWebViewStyles.bankname}>
              HDFC Bank
            </Typography> */}
            <div className={BankWebViewStyles.img_div}>
              <img
                src={hdfcbank}
                className={BankWebViewStyles.bank_img2}
                alt="bank"
              ></img>
            </div>


          </Grid2>

          <Grid2 className={BankWebViewStyles.middle_line}></Grid2>
          <Grid2 className={BankWebViewStyles.bank_card2}>
            {/* <Typography className={BankWebViewStyles.bankname}>
              ICICI Bank
            </Typography> */}
            <div className={BankWebViewStyles.img_div}>
              <img
                src={icicibank}
                className={BankWebViewStyles.bank_img3}
                alt="bank"
              ></img>
            </div>


          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
